module.exports = ({
    "CDMS300TT001": "e-Training",
    "CDMS300BTN001": "ดาวน์โหลดใบรับรอง",
    "CDMS300H001": "ชื่อเอกสาร",
    "CDMS300H002": "สถานะการอบรม",
    "CDMS300H003": "วันที่สำเร็จการอบรม",
    "CDMS300OPT001": "ผ่านการอบรม",
    "CDMS300OPT002": "ยังไม่ผ่านการอบรม",
    "CDMS300PL001": "เอกสาร",
    "CDMS300PL002": "หน้าที่",
    "TAB-SYSTEM-ETRAINING": "System e-Training",
    "TABLE-CM-NO": "No.",
    "TABLE-CM-USER-ID": "รหัสผู้ใช้งาน",
    "TABLE-COLUMN-SITE": "สถานวิจัย",
    "TABLE-COLUMN-ACTIVE-STATUS": "สถานะ",
    "TABLE-COLUMN-ETRAINING-FILE": "รายละเอียด e-training",
    "TABLE-COLUMN-COMPLETION-STATUS": "สถานะการดำเนินการ",
    "TABLE-COLUMN-COMPLETION-DATE": "วันที่สิั้นสุด",
    "TABLE-COLUMN-DOWNLOAD-CERTIFICATE": "ใบรับรอง",
    "BUTTON-CM-DOWNLOAD-ALL": "ดาวน์โหลดทั้งหมด",
    "LABEL-ACTIVE": "กำลังใช้งาน",
    "LABEL-INACTIVE": "ไม่ได้ใช้งาน",
    "LABEL-COMPLETED": "ผ่านการอบรม",
    "LABEL-INCOMPLETED": "ไม่สมบูรณ์",
    "BUTTON-CM-DOWNLOAD": "ดาวน์โหลด"
});
